
export class ProjectAccomplishment {
    title:string= ''
    description:string= ''
    completionPercent:string= ''
    governorates:[]=[]
    projectcompletionimage:any
    
}
export class UpdateourProjectAccomplishment {
    id:number=null
    title:string= ''
    description:string= ''
    completionPercent:string= ''
    governoratesIds:string= ''
    projectcompletionimage:any



}